import React, { useState } from 'react';

const CursedTextGenerators = () => {
  const [inputText, setInputText] = useState('');
  const [cursedText, setCursedText] = useState('');
  const [selectedStyle, setSelectedStyle] = useState('glitch');

  const handleInputChange = (e) => {
    setInputText(e.target.value);
    applyTextTransformation(e.target.value, selectedStyle);
  };

  const handleStyleChange = (e) => {
    setSelectedStyle(e.target.value);
    applyTextTransformation(inputText, e.target.value);
  };

  const applyTextTransformation = (text, style) => {
    let transformedText = text;

    
    const zalgo = {
      'a': 'a̷̸̡͍̲͉͕͙̳̫͌͌́̕͝', 'b': 'b̶̛̟̙͓̯̻̦́̈́͛̑̕', 'c': 'c̶̡̻̪͖̤̜̠̾ͯ̐', 'd': 'ḏ̶̯͓͚͙̰̙́̕͠', 'e': 'e̴̼͖̯̻͙̦͌͛̓̽',
      'f': 'f̵̤̼͓̦̳͇͛̄͌͒', 'g': 'g̸̢̨͙̰̲̝̤̔̓͢', 'h': 'h̸̘͎̪͚̽͑͜', 'i': 'i̮̩̾ͯ͘͡', 'j': 'j͙͎͍̾͑̕',
      'k': 'k̟̩͓̮͒́ͅ', 'l': 'l̛̺̝̮̀̀͡', 'm': 'm̦͙̘̳͒̾', 'n': 'n̟̗̪̽ͦ͟', 'o': 'o͙̞̲͎͍͘͡',
      'p': 'p̤̝͏̠̘̩̓', 'q': 'q̛̥͓͆ͯ͢', 'r': 'r͓̩̦͏͌', 's': 's̟̤̠͇̤̬ͅ', 't': 't̻͈̮̳̟',
      'u': 'u̶̻̦͗̄͜', 'v': 'v̜͕͙̚͡', 'w': 'w̯̘̮̗͞', 'x': 'x̦͇̺̝͙̰', 'y': 'y̨̗̻͚̯',
      'z': 'z̩̞̙͍̤̕', 'A': 'A̢̛̹͔͑', 'B': 'B̰͓͒͞', 'C': 'C̡̛͕̞̘̕', 'D': 'D̛̙͗',
      'E': 'E̛̮̪͡', 'F': 'F̛̮͔͢', 'G': 'G̛͖̯͜', 'H': 'H̨̤̯͋', 'I': 'I̛̮̖͡',
      'J': 'J͙͎̰̾͠', 'K': 'K̟̩̘', 'L': 'L̛͓̪̼͡', 'M': 'M̛̦͙͌̾', 'N': 'N̟̗͈̒',
      'O': 'O͙͔̱̦͘͠', 'P': 'P̤̝̩̯̕', 'Q': 'Q̥̹͢', 'R': 'R̢͓̩̤̾', 'S': 'S̟̤̳̓',
      'T': 'T̻͈̘͝', 'U': 'U̻̦͋', 'V': 'V̜̥͡', 'W': 'W̨̯̘̗', 'X': 'X̦͇̳̽',
      'Y': 'Y̗̻͙̩', 'Z': 'Z̷̠̱̙̪̾̇',
      '0': '0̴̖͕̟́̈́', '1': '1̸͖̤̥̱ͅ', '2': '2̶͇̱͒̀', '3': '3̶̛̱͌', '4': '4̴̲̦̠',
      '5': '5̴̛̪͚͡', '6': '6̶̩͙͋̽', '7': '7̷̦̺͓̚', '8': '8̸̻͈͘͞', '9': '9̴̢̛̻͇',
    };
    

    
    const boldScript = {
      'a': '𝗮', 'b': '𝗯', 'c': '𝗰', 'd': '𝗱', 'e': '𝗲',
      'f': '𝗳', 'g': '𝗴', 'h': '𝗵', 'i': '𝗶', 'j': '𝗷',
      'k': '𝗸', 'l': '𝗹', 'm': '𝗺', 'n': '𝗻', 'o': '𝗼',
      'p': '𝗽', 'q': '𝗾', 'r': '𝗿', 's': '𝘀', 't': '𝘁',
      'u': '𝘂', 'v': '𝘃', 'w': '𝘄', 'x': '𝘅', 'y': '𝘆',
      'z': '𝘇', 'A': '𝗔', 'B': '𝗕', 'C': '𝗖', 'D': '𝗗',
      'E': '𝗘', 'F': '𝗙', 'G': '𝗚', 'H': '𝗛', 'I': '𝗜',
      'J': '𝗝', 'K': '𝗞', 'L': '𝗟', 'M': '𝗠', 'N': '𝗡',
      'O': '𝗢', 'P': '𝗣', 'Q': '𝗤', 'R': '𝗥', 'S': '𝗦',
      'T': '𝗧', 'U': '𝗨', 'V': '𝗩', 'W': '𝗪', 'X': '𝗫',
      'Y': '𝗬', 'Z': '𝗭'
    };

    
    const doubleStruck = {
      'a': '𝕒', 'b': '𝕓', 'c': '𝕔', 'd': '𝕕', 'e': '𝕖',
      'f': '𝕗', 'g': '𝕘', 'h': '𝕙', 'i': '𝕚', 'j': '𝕛',
      'k': '𝕜', 'l': '𝕝', 'm': '𝕞', 'n': '𝕟', 'o': '𝕠',
      'p': '𝕡', 'q': '𝕢', 'r': '𝕣', 's': '𝕤', 't': '𝕥',
      'u': '𝕦', 'v': '𝕧', 'w': '𝕨', 'x': '𝕩', 'y': '𝕪',
      'z': '𝕫', 'A': '𝔸', 'B': '𝔹', 'C': 'ℂ', 'D': '𝔻',
      'E': '𝔼', 'F': '𝔽', 'G': '𝔾', 'H': 'ℍ', 'I': '𝕀',
      'J': '𝕁', 'K': '𝕂', 'L': '𝕃', 'M': '𝕄', 'N': 'ℕ',
      'O': '𝕆', 'P': 'ℙ', 'Q': 'ℚ', 'R': 'ℝ', 'S': '𝕊',
      'T': '𝕋', 'U': '𝕌', 'V': '𝕍', 'W': '𝕎', 'X': '𝕏',
      'Y': '𝕐', 'Z': 'ℤ'
    };

    
    const fraktur = {
      'a': '𝖆', 'b': '𝖇', 'c': '𝖈', 'd': '𝖉', 'e': '𝖊',
      'f': '𝖋', 'g': '𝖌', 'h': '𝖍', 'i': '𝖎', 'j': '𝖏',
      'k': '𝖐', 'l': '𝖑', 'm': '𝖒', 'n': '𝖓', 'o': '𝖔',
      'p': '𝖕', 'q': '𝖖', 'r': '𝖗', 's': '𝖘', 't': '𝖙',
      'u': '𝖚', 'v': '𝖛', 'w': '𝖜', 'x': '𝖝', 'y': '𝖞',
      'z': '𝖟'
    };

    
    const circled = {
      'a': 'ⓐ', 'b': 'ⓑ', 'c': 'ⓒ', 'd': 'ⓓ', 'e': 'ⓔ',
      'f': 'ⓕ', 'g': 'ⓖ', 'h': 'ⓗ', 'i': 'ⓘ', 'j': 'ⓙ',
      'k': 'ⓚ', 'l': 'ⓛ', 'm': 'ⓜ', 'n': 'ⓝ', 'o': 'ⓞ',
      'p': 'ⓟ', 'q': 'ⓠ', 'r': 'ⓡ', 's': 'ⓢ', 't': 'ⓣ',
      'u': 'ⓤ', 'v': 'ⓥ', 'w': 'ⓦ', 'x': 'ⓧ', 'y': 'ⓨ',
      'z': 'ⓩ', 'A': 'ⓐ', 'B': 'ⓑ', 'C': 'ⓒ', 'D': 'ⓓ',
      'E': 'ⓔ', 'F': 'ⓕ', 'G': 'ⓖ', 'H': 'ⓗ', 'I': 'ⓘ',
      'J': 'ⓙ', 'K': 'ⓚ', 'L': 'ⓛ', 'M': 'ⓜ', 'N': 'ⓝ',
      'O': 'ⓞ', 'P': 'ⓟ', 'Q': 'ⓠ', 'R': 'ⓡ', 'S': 'ⓢ',
      'T': 'ⓣ', 'U': 'ⓤ', 'V': 'ⓥ', 'W': 'ⓦ', 'X': 'ⓧ',
      'Y': 'ⓨ', 'Z': 'ⓩ'
    };

    
    const transformations = {
      glitch: text.split('').map(char => zalgo[char] || char).join(''),
      boldScript: text.split('').map(char => boldScript[char] || char).join(''),
      doubleStruck: text.split('').map(char => doubleStruck[char] || char).join(''),
      fraktur: text.split('').map(char => fraktur[char] || char).join(''),
      circled: text.split('').map(char => circled[char] || char).join(''),
    };

    transformedText = transformations[style] || text;
    setCursedText(transformedText);
  };

  const handleCopyClick = () => {
    navigator.clipboard.writeText(cursedText);
  };

  return (
    <div className="container mt-5 p-4 bg-white rounded shadow-md max-w-lg mx-auto">
      <textarea
        className="form-control mb-3"
        value={inputText}
        onChange={handleInputChange}
        placeholder="Enter your text here..."
      />
      <div className="mb-3">
        <label className="form-label fw-bold">Select Style:</label>
        <select
          className="form-select"
          value={selectedStyle}
          onChange={handleStyleChange}
        >
          <option value="glitch">Glitch</option>
          <option value="boldScript">Bold</option>
          <option value="doubleStruck">Double Struck</option>
          <option value="fraktur">Fraktur</option>
          <option value="circled">Circled</option>
        </select>
      </div>
      <div className="mb-4">
        <h2 className="h5 text-secondary">Cursed Text:</h2>
        <p className="text-muted">{cursedText}</p>
      </div>
      <button
        className="btn btn-primary"
        onClick={handleCopyClick}
      >
        Copy Cursed Text
      </button>
    </div>
  );
};

export default CursedTextGenerators;
